<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t('SIDENAV.SecurityCompanies.add') }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #26a1d6">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Company Name -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SIDENAV.SecurityCompanies.name')"
            v-model.trim="data.name"
            :rules="[
              (val) => !!val || $t('VALIDATION.required'),
              (val) => (val && val.length >= 3) || $t('SIDENAV.SecurityCompanies.nameLengthMin'),
              (val) => (val && val.length <= 50) || $t('SIDENAV.SecurityCompanies.nameLengthMax'),
            ]"
            required
          />
          <!-- End:: Company Name -->

          <!-- Start:: Mobile Input -->
          <base-phone-input
            col="6"
            required
            v-model="data.mobile"
            @dialCode="dialCode"
            @isoCode="isoCode"
            :placeholder="$t('SIDENAV.SecurityCompanies.mobile')"
            :defaultCountry="data.iso_code"
            :key="key"
          />
          <!-- <base-input
            col="6"
            required
            v-model="data.phone"
             type="tel"
             :placeholder="$t('SIDENAV.SecurityCompanies.mobile')"
            /> -->
          <!-- End:: Mobile Input -->

          <!-- Start:: Email Input -->
          <base-input
            col="6"
            type="email"
            :placeholder="$t('SIDENAV.SecurityCompanies.email')"
            v-model.trim="data.email"
            required
          />
          <!-- End:: Email Input -->

          <!-- Start:: Commercial Registration Number -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SIDENAV.SecurityCompanies.commercialNumberPlaceholder')"
            v-model.trim="data.commercial_registration_number"
            @input="validateCommercialNumber"
            :rules="[
              (val) => !!val || $t('VALIDATION.required'),
              (val) => /^\d{10}$/.test(val) || $t('SIDENAV.SecurityCompanies.commercialNumberValidation'),
            ]"
            required
          />
          <!-- End:: Commercial Registration Number -->

          <!-- Start:: Commercial Registration Image -->
          <base-image-upload-input
            col="12"
            identifier="commercial_registration_image"
            :placeholder="$t('SIDENAV.SecurityCompanies.commercialImagePlaceholder')"
            @selectImage="selectImage"
            :disabled="!isCommercialNumberValid"
          />
          <div v-if="!isCommercialNumberValid" class="col-12 mb-3">
            <small class="text-danger">
              {{ $t('SIDENAV.SecurityCompanies.commercialImageValidation') }}
            </small>
          </div>
          <!-- End:: Commercial Registration Image -->

          <input
            type="text"
            name="fake-user"
            style="display: none"
            autocomplete="username"
          />
          <input
            type="password"
            name="fake-pass"
            style="display: none"
            autocomplete="new-password"
          />

          <!-- Start:: Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('SIDENAV.SecurityCompanies.password')"
            v-model.trim="data.password"
            :rules="[
              (val) => !!val || $t('VALIDATION.required'),
              (val) => (val && val.length >= 8) || $t('SIDENAV.SecurityCompanies.passwordMinLength'),
              (val) => /[A-Z]/.test(val) || $t('SIDENAV.SecurityCompanies.passwordUppercase'),
              (val) => /[a-z]/.test(val) || $t('SIDENAV.SecurityCompanies.passwordLowercase'),
              (val) => /[0-9]/.test(val) || $t('SIDENAV.SecurityCompanies.passwordNumber'),
              (val) => /[@$!%*?&#]/.test(val) || $t('SIDENAV.SecurityCompanies.passwordSpecial'),
            ]"
            required
          />
          <!-- End:: Password Input -->

          <!-- Start:: Confirm Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('SIDENAV.SecurityCompanies.confirmPassword')"
            v-model.trim="data.password_confirmation"
            :rules="[
              (val) => !!val || $t('VALIDATION.required'),
              (val) => val === data.password || $t('SIDENAV.SecurityCompanies.passwordMismatch'),
            ]"
            required
          />
          <!-- End:: Confirm Password Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BasePhoneInput from "@/components/formInputs/BasePhoneInput.vue";
export default {
  name: "CreateArea",
  components: {
    BasePhoneInput,
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        commercial_registration_image: {
          path: null,
          file: null,
        },
        name: null,
        email: null,
        mobile: null,
        commercial_registration_number: null,
        password: null,
        password_confirmation: null,
        dial_code: null,
        iso_code: null,
      },
      isCommercialNumberValid: false,
      // End:: Data Collection To Send
    };
  },

  methods: {
    isoCode(iosCode) {
      this.data.iso_code = iosCode;
    },
    dialCode(dialCode) {
      this.data.dial_code = dialCode;
    },
    selectImage(selectedImage) {
      this.data.commercial_registration_image = selectedImage;
    },
    validateCommercialNumber() {
      // Validate that commercial registration number is exactly 10 digits
      this.isCommercialNumberValid = /^\d{10}$/.test(
        this.data.commercial_registration_number
      );
      if (!this.isCommercialNumberValid) {
        this.data.commercial_registration_image = {
          path: null,
          file: null,
        };
      }
    },
    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      
      REQUEST_DATA.append("name", this.data.name);
      REQUEST_DATA.append("email", this.data.email);
      REQUEST_DATA.append("mobile", this.data.mobile);
      REQUEST_DATA.append("country_code", "+" + this.data.dial_code);
      REQUEST_DATA.append("iso_code", this.data.iso_code);
      REQUEST_DATA.append(
        "user_info[commercial_registration_number]",
        this.data.commercial_registration_number
      );
      
      if (this.data.commercial_registration_image.file) {
        REQUEST_DATA.append("commercial_registration_image", this.data.commercial_registration_image.file);
      }
      
      REQUEST_DATA.append("password", this.data.password);
      REQUEST_DATA.append(
        "password_confirmation",
        this.data.password_confirmation
      );

      try {
        await this.$axios({
          method: "POST",
          url: `providers`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/providers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response?.data?.message || error.message);
      }
    },
    // End:: Submit Form
  },

  async created() {
    // Initialization if needed
  },
};
</script>
